import { render, staticRenderFns } from "./submission-tab-team-members.vue?vue&type=template&id=5a2c8546&scoped=true&"
import script from "./submission-tab-team-members.vue?vue&type=script&lang=ts&"
export * from "./submission-tab-team-members.vue?vue&type=script&lang=ts&"
import style0 from "./submission-tab-team-members.vue?vue&type=style&index=0&id=5a2c8546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2c8546",
  null
  
)

export default component.exports